<template>
    <div>
        <div class="table-action-header">
            <div class='search-options'>
                <b-form-datepicker 
                    id="messagedate" 
                    v-model="messageDate" 
                    class="mb-2"
                    :locale="this.$t('datepicker.locale')" 
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }" 
                />
            </div>
            <div class='search-options'>
                <SelectList :options="directionOptions" :value="direction" :searchable="false" :clearable="false" v-on:select="direction = $event"/>
            </div>
            <div class='search-options'>
                <SelectList :options="destinationOptions" :value="destination" :searchable="true" :clearable="false" v-on:select="destination = $event"/>
            </div>
        </div>
        
        <b-table
            striped
            hover
            sticky-header="70vh"
            small
            :items=items
            :fields=fields
            :sort-by='sortBy'
            :sort-desc='sortDesc'
            :sort-compare='sortCompare'
            :filter-function="filterMethod"
            @filtered="onFiltered"
            :filter = "filter"
            >
            <template #cell(msg)="data">
                {{ data.item.body.msg }}
            </template>
            <template #cell(target)="data">
                <participant :direction="data.item.direction" :type="data.item.sender.type" :id="data.item.sender.value"/>
            </template>
            <template #cell(time)="data">
                {{ data.item.sendTime | tsFilter }}
            </template>
            <template #cell(direction)="data">
                <b-icon v-if="data.item.direction == 'in'" icon="box-arrow-in-right" variant="dark" scale='2'></b-icon>
                <b-icon v-if="data.item.direction == 'out'" icon="box-arrow-right" variant="dark" scale='2'></b-icon>
            </template>
        </b-table>
    </div>
</template>

<script>
import moment from 'moment'
import usermessage from '@/store/dispatching/usermessage.js'
import participant from '@/components/Dispatching/UserMessageParticipant'

function capitalize(str) {
    let capStr = str.trim()
    return capStr.replace(/^\w/, (c) => c.toUpperCase());
}

export default {
    components: { participant },
    data: function() {
        return {
            fields: [
                {key: 'direction' , label: '', },
                {key:'target' , label: this.$t('user_messages.target'),sortable:false},
                {key:'time', label:this.$t('user_messages.time'), sortable:false},
                {key:'msg' ,label:this.$t('user_messages.message') , sortable:false}
            ],
            sortBy:'time',
            sortDesc: false,
            direction: 'all',
            destination:'all',
            messageUpdateTimer: null,
            messageDate: null,
            filter: 'null',
            directionOptions: [
                { id:'all' , label: this.$t('user_messages.all') , icon:'list'},
                { id:'in' ,label: this.$t('user_messages.incoming') , icon:'box-arrow-in-right'},
                { id:'out' ,label: this.$t('user_messages.outgoing') , icon:'box-arrow-right'}
            ]
            
        }
    },
    computed: {
        items () {
            return this.$store.state.usermessage.usermessageList
        },
        destinationOptions() {
            if( this.$store.state.usermessage.usermessageList == null ||
                this.$store.state.usermessage.usermessageList.length == 0 )
                return [{id: "all" , label: this.$t('user_messages.all') , icon:'list' }]

            let list = this.$store.state.usermessage.usermessageList.reduce((accumulator,currentValue) => {
               
                let ret = accumulator    
                if( accumulator.length == 0 ) {
                    ret = [{id: "all" , label: this.$t('user_messages.all') , icon:'list' }]
                }
               
                let newValue = null
                
                if( currentValue.direction == 'out' )
                    newValue = { id: currentValue.receiver.value , label: this.translateDestType(currentValue.receiver.type) + " - " + currentValue.receiver.value }
                if( currentValue.direction == 'in' )
                    newValue = { id: currentValue.sender.value, label: this.translateDestType(currentValue.sender.type) + " - " +currentValue.sender.value }
                
                if( newValue != null && !ret.find((cur) => {
                    return newValue.id == cur.id && newValue.label == cur.label
                }))
                    ret.push(newValue)
                
                return ret
            } , [] )
            
           return list.sort((first,second) => {
                if( first.id == 'all')
                    return -1
                if( second.id =='all')
                    return 1
                return first.id > second.id
            })
            
        }
    },
    beforeCreate() {
        if( !this.$store.state.usermessage ) {
            this.$store.registerModule("usermessage" , usermessage )
        }
        
    },
    created() {
        this.messageDate = new Date()
    },
    mounted() {
        this.updateMessages()
    },
    beforeDestroy() {
        clearTimeout(this.messageUpdateTimer)
    },
    watch: {
        direction: function( data ) {
            this.filter = data
        },
        messageDate: function() {
            this.updateMessages()
        }
    },
    filters: {
        tsFilter(value) {
            return moment(String(value)).format("DD.MM.YYYY HH:mm")
        },
        capFilter(value) {
            return capitalize(value)
        }
        
    },
    methods:{
        filterMethod(item ) {
            let dirFilter = true
            if( this.direction != 'all')
                dirFilter = this.direction == item.direction
            let destinationFilter = true
        
            if( this.destination != null && this.destination != 'all') {
                if( item.direction == 'out' )
                    destinationFilter = this.destination == item.receiver.value
                if( item.direction == 'in')
                    destinationFilter = this.destination == item.sender.value
            }

            return dirFilter && destinationFilter
        },
        sortCompare( row1, row2, sortBy ) {
            if( sortBy == 'time' ) {
                let time1 = moment(String(row1.sendTime) )
                let time2 = moment(String(row2.sendTime) )
                if( time1.isSame(time2))
                    return 0;

                if( time1.isBefore(time2))
                    return 1;
                else
                    return -1  
            } 
        },
        updateMessages() {
            clearTimeout(this.messageUpdateTimer)
            this.$store.commit("events/setMessagesViewTime")
            this.$store.dispatch('usermessage/getUserMessagesForDay' , this.messageDate )
            this.messageUpdateTimer = setTimeout( this.updateMessages , 5000 )
        },
        translateDestType(value) {
            let int18Str = `user_messages.destination_type.${value}`
            return this.$t(int18Str)
        }
    }
}
</script>

<style scoped lang="scss">

.table-action-header {
  height: 50px;
}


div.search-input {
  width: 200px;
  float: left;
  /*
  margin-right: 10px;*/
}

div.search-options {
  width: 200px;
  float: left;
  margin-right: 10px;
}

#new-item {
  margin: 0;
}

#new-item span {
  display: none;
}
#new-item:hover span {
  display: inline;
}

.b-table-sticky-header {
    min-width: fit-content;
}
</style>